import IBaseListingResponse from "../../utils/api/base-listing-response";
import {ICampaign, ICampaignDetails} from "../../models/campaign/response";
import {ICampaignQuery} from "../../models/campaign/query";
import {DEFAULT_FUNCTION, DEFAULT_QUERY} from "../../utils/helpers/constants";
import {ICreateCampaign, IUpdateCampaign} from "../../models/campaign/request";
import {createContext} from "react";

export type CampaignLoading =
    | "list"
    | "details"
    | "create"
    | "update"
    | "delete";

export interface IInternalState {
  allCampaigns?: ICampaign[];

  loading: CampaignLoading[];
  list?: IBaseListingResponse<ICampaign>;
  query: ICampaignQuery;
  details?: ICampaignDetails;
}

export const internalState: IInternalState = {
  loading: [],
  query: DEFAULT_QUERY,
};

export interface IExternalState extends IInternalState {
  actions: {
    getData: () => void;
    getDetails: (id: number) => void;
    setDetails: (data?: ICampaignDetails) => void;
    createCampaign: (request: ICreateCampaign) => void;
    updateCampaign: (id: number, request: IUpdateCampaign) => void;
    deleteCampaign: (id: number) => void;
    setSearch: (search?: string) => void;
    setQuery: (query: ICampaignQuery) => void;
  };
}

export const externalState: IExternalState = {
  ...internalState,
  actions: {
    getData: DEFAULT_FUNCTION,
    getDetails: DEFAULT_FUNCTION,
    setDetails: DEFAULT_FUNCTION,
    createCampaign: DEFAULT_FUNCTION,
    updateCampaign: DEFAULT_FUNCTION,
    deleteCampaign: DEFAULT_FUNCTION,
    setSearch: DEFAULT_FUNCTION,
    setQuery: DEFAULT_FUNCTION,
  },
};

const CampaignContext = createContext(externalState);

export default CampaignContext;